import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { ArrowRight } from "lucide-react";
import { ARTICLES } from "@/data/journal";

export default function Journal() {
  return (
    <section id="journal" data-testid="journal-section" className="bg-sand/40 py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-clay">
            <span className="h-px w-10 bg-clay" /> Patient journal
          </p>
          <h2 className="max-w-xl font-serif text-4xl font-light leading-tight tracking-tighter text-forest sm:text-5xl" data-testid="journal-heading">
            Notes on moving and feeling better.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-2">
          {ARTICLES.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.1}>
              <Link
                to={`/journal/${a.slug}`}
                data-testid={`journal-article-${a.slug}`}
                className="group flex h-full flex-col border border-forest/10 bg-bone p-8 transition-all duration-500 hover:-translate-y-2 hover:border-pine/30 hover:shadow-2xl hover:shadow-pine/10 lg:p-12"
              >
                <p className="text-xs uppercase tracking-[0.2em] text-clay">
                  {a.date} · {a.readTime}
                </p>
                <h3 className="mt-6 font-serif text-3xl font-light leading-snug tracking-tight text-forest lg:text-4xl">
                  {a.title}
                </h3>
                <p className="mt-4 flex-1 text-sm leading-relaxed text-forest/70">{a.excerpt}</p>
                <p className="mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-pine">
                  Read the article
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
